	 <h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
         <div>
		<div class="ui small icon fluid input" style="margin: 5px;">
                        <input type="text" placeholder="Search document..."   [formControl]="search" />
                        <i class="search icon"></i>
                  </div>
            </div>
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
        <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
        <esl-message-toast [(message)]="error"></esl-message-toast>
      </div>
<div class="detail-panel link" *ngFor="let document of documents" appMargin marginB="10">
	<div fxLayout="row" fxLayoutAlign='space-between center'>
		<div fxFlex="grow">
			<h4 class="sub-header">{{document?.name}}</h4>
			<div class="sub-item">Created By <label class="ui circular link grey label">{{document?.createdBy}}</label>  &nbsp; &nbsp;  &nbsp; &nbsp; Last Edited <label class="ui circular link grey label">{{document?.dateCreated}}</label></div>
		</div>
	</div>
</div>

       </div>
 </div>
      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Create Document </button>

      </div>


